import { useState, useEffect } from "react";

/**
 * Define a custom hook for storing values in session storage or local storage
 * @param key 
 * @param initialValue 
 * @returns 
 */

const useBrowserStorage = (key: any, initialValue: any) => {
  const [value, setValue] = useState(() => {
    const storedValue = sessionStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : initialValue;
  });

  useEffect(() => {
    if (value) sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}

export default useBrowserStorage;